/* eslint-disable max-len */
import React, { Fragment, useRef, useState } from 'react';
import 'tw-elements';
import TableBody from './TableBody';
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

const Table = ({
    pageNumber,
    getListData,
    setToastErrorMessage,
    setConfirmationState, handleSidePopupClick, email, setLoading, totalCount }) => {
    const dispactch = useDispatch()
    const [selectedIndex, setSelectedIndex] = useState(null);
    const selectedRef = useRef();
    const inventoryList = useSelector(state => state.InventoryListSlice);
    const { List } = inventoryList
    const [searchParams, setSearchParams] = useSearchParams()


    /* `useOnClickOutside` is a custom hook that takes two arguments: a ref and a callback function. It
    is used to detect clicks outside of a specific element (in this case, the `selectedRef` element)
    and trigger the callback function (`setSelectedIndex(null)`) when a click is detected outside of
    that element. In this specific code, it is used to close a dropdown menu when a user clicks
    outside of it. */
    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });

    /**
     * The function handles sorting based on a given key and current sort value.
     */

    const noSearchOrFilter = searchParams.get('search') === null && searchParams.get('filter') === null;

    return (<>
        <div className='-mx-1'>
            <div className={`flex mb-3 overflow-auto ${List?.data?.length < 10 ? 'pb-[100px]' : 'pb-[6px]'} scroll-bar px-1`} id="search-result" >
                <table aria-label="Outside Table" className="w-full" id='admin-table'>
                    <thead>
                        <tr>
                            <th class="w-[14%]">
                                <span >Item Code
                                </span>
                            </th>
                            <th class="w-[18%]">
                                <span >Item Name
                                </span>
                            </th>
                            <th class="w-[10%]">
                                <span >UoM
                                </span>
                            </th>
                            <th class="w-[14%]">
                                <span class="flex items-center justify-end">Total Stock Qty
                                </span>
                            </th>
                            <th class="w-[12%]">
                                <span class="flex items-center justify-end">Selling Price
                                </span>
                            </th>
                            <th class="w-[6%]">
                                <span >
                                </span>
                            </th>
                            <th class="w-[11%]">
                                <div className='flex justify-center'>
                                    <span >Status
                                    </span>
                                </div>
                            </th>
                            <th class="w-[8%]">
                                <span class="flex items-center justify-center">Actions
                                </span>
                            </th>
                        </tr>
                        <tr aria-colspan="7" class="h-1"></tr>

                    </thead>
                    <tbody>
                        {List?.data?.map((item, index = 0) => (
                            <Fragment key={item._id}>
                                <TableBody
                                    tableData={item}
                                    setConfirmationState={setConfirmationState}
                                    indexNum={index}
                                    pageNumber={pageNumber}
                                    selectedIndex={selectedIndex}
                                    setSelectedIndex={setSelectedIndex}
                                    selectedRef={selectedRef}
                                    lastIndex={List?.data?.length}
                                    email={email}
                                    searchParams={searchParams}
                                    handleSidePopupClick={handleSidePopupClick}
                                    getListData={getListData}
                                    setLoading={setLoading}
                                    setToastErrorMessage={setToastErrorMessage}
                                />
                            </Fragment>
                        ))}

                    </tbody>
                    {List?.data?.length === 0 && (
                        <tbody>
                            <tr>
                                <td style={{ 'line-height': '100px' }} colspan="7" className="no-records-message" id='no-matching-result'>
                                    {noSearchOrFilter ? `No Inventory added yet.` : 'No matching records found.'}
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
        </div>
    </>
    );
}

export default Table;
